<template>
  <div class="home-page">
    <AppHeader :is-desktop="isDesktop" @download="goDownload" />
    <main>
      <HeroBanner :banners="banners" />

      <section class="content-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title section-title--clickable" @click="goDownload">课程推荐</h2>
            <a href="#" class="see-more" @click.prevent="goDownload">›</a>
          </div>
          <div class="scroll-row">
            <CourseCard
              v-for="course in courses"
              :key="course.id"
              :course="course"
              @click="goDownload"
            />
          </div>
        </div>
      </section>

      <SectionArrow />

      <section class="content-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title section-title--clickable" @click="goDownload">名师推荐</h2>
            <a href="#" class="see-more" @click.prevent="goDownload">›</a>
          </div>
          <div class="scroll-row">
            <TeacherCard
              v-for="teacher in teachers"
              :key="teacher.id"
              :teacher="teacher"
              @click="goDownload"
            />
          </div>
        </div>
      </section>

      <SectionArrow />

      <section class="content-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title section-title--clickable" @click="goDownload">考学资讯</h2>
            <a href="#" class="see-more" @click.prevent="goDownload">›</a>
          </div>
          <div class="scroll-row">
            <ArticleCard
              v-for="article in articles"
              :key="article.id"
              :article="article"
              @click="goDownload"
            />
          </div>
        </div>
      </section>

      <AppCTA @download="goDownload" />
    </main>
    <AppFooter @link-click="goDownload" />
    <StickyDownload @download="goDownload" />
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader.vue'
import HeroBanner from '../components/HeroBanner.vue'
import CourseCard from '../components/CourseCard.vue'
import TeacherCard from '../components/TeacherCard.vue'
import ArticleCard from '../components/ArticleCard.vue'
import SectionArrow from '../components/SectionArrow.vue'
import AppCTA from '../components/AppCTA.vue'
import AppFooter from '../components/AppFooter.vue'
import StickyDownload from '../components/StickyDownload.vue'
import {
  fetchBanners,
  fetchCourses,
  fetchTeachers,
  fetchNews,
} from '../api/home'

export default {
  name: 'HomePage',
  components: {
    AppHeader,
    HeroBanner,
    CourseCard,
    TeacherCard,
    ArticleCard,
    SectionArrow,
    AppCTA,
    AppFooter,
    StickyDownload,
  },
  data() {
    return {
      banners: [],
      courses: [],
      teachers: [],
      articles: [],
      isDesktop: false,
    }
  },
  mounted() {
    this.checkDesktop()
    window.addEventListener('resize', this.checkDesktop)
    this.loadData()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkDesktop)
  },
  methods: {
    checkDesktop() {
      this.isDesktop = window.innerWidth >= 768
    },
    async loadData() {
      const [banners, courses, teachers, articles] = await Promise.all([
        fetchBanners().catch(() => []),
        fetchCourses().catch(() => []),
        fetchTeachers().catch(() => []),
        fetchNews().catch(() => []),
      ])
      this.banners = banners
      this.courses = courses
      this.teachers = teachers
      this.articles = articles
    },
    goDownload() {
      this.$router.push('/download')
    },
  },
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

.content-section {
  padding: 20px 0;
}

@media (min-width: 768px) {
  .content-section {
    padding: 28px 0;
  }
}
</style>
